module.exports = __webpack_public_path__ + "media/images/icons/SVG/054-543263ab251acbb5315c9bfaacafd627.svg";